var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { NgZone } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { bufferTime, filter, map, mergeMap, observeOn } from 'rxjs/operators';
import { async } from 'rxjs/scheduler/async';
import { isRequestDataAction, } from './actions';
import { ApiHttp } from './api-http.service';
import { uniq } from './helpers';
import { mergeAll } from './operators';
import { referencesEqual } from './store.helpers';
import { enterZone, leaveZone } from './zone-util';
/**
 * Batch requests to group requests of the same endpoint with IDs to one
 * endpoint with a maximum of 1000 IDs.
 * @param requests The requests to batch.
 * @returns Batched requests.
 */
function batchRequests(requests) {
    var requestsToBatch = {};
    var finishedRequests = [];
    requests.forEach(function (request) {
        if (request.ref.query) {
            // We don't batch queries. Immediately put them in the finished pile.
            finishedRequests = finishedRequests.concat([request]);
        }
        else if (requestsToBatch[request.type + "-" + request.ref.path.authUid] ===
            undefined) {
            requestsToBatch[request.type + "-" + request.ref.path.authUid] = request;
        }
        else {
            var path = {
                collection: request.ref.path.collection,
                authUid: requestsToBatch[request.type + "-" + request.ref.path.authUid].ref
                    .path.authUid,
                ids: (requestsToBatch[request.type + "-" + request.ref.path.authUid].ref
                    .path.ids || []).concat((request.ref.path.ids || [])),
            };
            var payload = { type: request.type, ref: { path: path } };
            // Limit batching of IDs to only 1000 IDs per request.
            if ((path.ids || []).length > 1000) {
                finishedRequests = finishedRequests.concat([payload]);
                delete requestsToBatch[request.type + "-" + request.ref.path.authUid];
            }
            else {
                requestsToBatch[request.type + "-" + request.ref.path.authUid] = payload;
            }
        }
    });
    // No more requests to batch, combine the unbatchable requests with the rest of
    // the batchable requests for processing.
    return finishedRequests.concat(Object.values(requestsToBatch));
}
// TODO type refs/uniq back properly
var RequestDataEffect = /** @class */ (function () {
    function RequestDataEffect(apiHttp, actions, ngZone) {
        var _this = this;
        this.apiHttp = apiHttp;
        this.actions = actions;
        this.ngZone = ngZone;
        this.requestData = this.actions.pipe(filter(isRequestDataAction), map(function (action) { return action.payload; }), bufferTime(250, leaveZone(this.ngZone, async)), filter(function (requests) { return requests.length > 0; }), observeOn(enterZone(this.ngZone, async)), map(function (requests) {
            var uniqRequests = uniq(requests, function (a, b) {
                return referencesEqual(a.ref, b.ref);
            });
            return batchRequests(uniqRequests);
        }), mergeAll(), mergeMap(function (request) { return _this.apiHttp.fetch(request.ref); }, function (request, res) { return ({ res: res, request: request }); }), map(function (_a) {
            var res = _a.res, request = _a.request;
            switch (res.status) {
                case 'success': {
                    var action = {
                        type: 'API_FETCH_SUCCESS',
                        payload: {
                            type: request.ref.path.collection,
                            result: res.result,
                            ref: request.ref,
                        },
                    };
                    return action;
                }
                case 'error': {
                    var action = {
                        type: 'API_FETCH_ERROR',
                        payload: {
                            type: request.ref.path.collection,
                            message: res.message,
                            ref: request.ref,
                        },
                    };
                    return action;
                }
                default: {
                    var action = {
                        type: 'UNKNOWN_API_FETCH_ERROR',
                        payload: {
                            type: request.ref.path.collection,
                            message: res,
                            ref: request.ref,
                        },
                    };
                    return action;
                }
            }
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], RequestDataEffect.prototype, "requestData", void 0);
    return RequestDataEffect;
}());
export { RequestDataEffect };



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/core/request-data.effect.ts.pre-build-optimizer.js